export const CONTENT_CLIENT_PRIMA = "Para mayor información llámanos al 615-7272 en Lima o al 0-801-18010 en provincias";
